/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
"use client";

import { ProfileInfoDataInterface } from "@/modules/Astro/UserProfile/ProfilesInfo/profileTypes";
import styles from "./About.module.scss";

interface AboutProps {
  userData?: ProfileInfoDataInterface;
}

export default function About({ userData }: AboutProps) {
  const profile = userData?.profile;
  const name = profile?.name ?? "";
  const bio = profile?.bio ?? "";
  const about = profile?.about ?? "";
  const uniqueCaption = profile?.unique_caption ?? "";

  // if (!about || !uniqueCaption) return null;

  return (
    <section className={styles.card}>
      <div className={styles.heading}>
        <span className={styles.bar} />

        <h2>{name ? `Who ${name} is` : "About"}</h2>
      </div>

      {bio && <p className={styles.description}>{bio}</p>}

      {about && <p className={styles.description}>{about}</p>}

      {uniqueCaption && (
        <blockquote className={styles.quote}>"{uniqueCaption}"</blockquote>
      )}
    </section>
  );
}
